<template>
  <div class="chat-history">
    <el-tooltip class="item" effect="dark" :content="$t('Chat History')" placement="top">
      <i class="chat iconfont icontime" @click="showHistoryDialog"></i>
    </el-tooltip>

    <el-dialog :visible.sync="chatHistoryVisible" custom-class="chat-dialog-history" :before-close="handleClose" append-to-body>
      <div slot="title">
        <img class="chat-title__avatar" :src="receiver.avatar || defImage('actor')" />
        <span class="chat-title__name"> {{ $t('Someone chat history', [`${receiver.name}`]) }}</span>
        <button type="button" class="el-dialog__headerbtn">
          <i class="el-dialog__close el-icon el-icon-close"></i>
        </button>
      </div>

      <div class="history-list">
        <template v-if="historyMsgList.length > 0">
          <div v-for="item in historyMsgList" :key="item.id" class="msg-item">
            <div class="msg-item-avatar">
              <img v-if="isReceivedMsg(item)" class="chat-title__avatar" :src="receiver.avatar || defImage('actor')" />
              <img v-else class="chat-title__avatar" :src="headImage || defImage('actor')" />
            </div>
            <div class="msg-item-content">
              <div v-if="isReceivedMsg(item)" class="chat-username">{{ receiver.name }}</div>
              <div v-else class="chat-username">{{ name }}</div>

              <img :src="item.msg || item.url" v-if="item.type === 'img' || item.contentsType === 'IMAGE'" class="img-style" />

              <el-card :body-style="{ padding: '0px' }" v-else-if="item.type === 'file' || item.contentsType === 'FILE'" class="file-style">
                <div class="card-inner">
                  <h2>{{ $t('File') }}</h2>
                  <span>
                    <h3>{{ item.filename }}</h3>
                  </span>
                  <div class="bottom clearfix">
                    <span>{{ readablizeBytes(item.file_length) }}</span>
                    <a :href="item.msg || item.url" :download="item.filename">{{ $t('Download') }}</a>
                  </div>
                </div>
              </el-card>
              <div v-else-if="item.contentsType === 'audio'">
                <audio :src="item.msg" controls></audio>
              </div>
              <div class="msg" v-else v-html="renderTxt(item.msg || item.data)"></div>
            </div>
            <div class="msg-item-datetime">{{ renderTime(item.time) }}</div>
          </div>
        </template>

        <div v-else>
          {{ $t('common.noData') }}
        </div>

        <el-button v-if="canLoadMore[receivingUser]" :loading="isloading" type="primary" size="mini" class="loadmore-btn" @click="loadmore">{{
          $t('Load more')
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import WebIM from '@/utils/webIM'
import ChatMixin from '@/mixins/chat'
import config from '@/config'

export default {
  data: () => ({
    chatHistoryVisible: false,
    historyMsgList: [],
    isloading: false
  }),

  mixins: [ChatMixin],

  computed: {
    ...mapState(['receiver', 'receivingUser', 'canLoadMore', 'chatMsgList']),
    ...mapGetters(['headImage', 'name'])
  },

  methods: {
    showHistoryDialog() {
      this.historyMsgList = [].concat(this.chatMsgList)
      this.historyMsgList.reverse()
      this.chatHistoryVisible = true
    },
    handleClose() {
      this.chatHistoryVisible = false
    },
    loadmore() {
      this.isloading = true
      const options = {
        queue: this.receivingUser.toLowerCase(),
        isGroup: false,
        count: config.chatFetchCount,
        success: res => {
          this.$store.commit('setLoadMoreArr', { imAccount: this.receivingUser, value: res.length === config.chatFetchCount })
          this.$store.commit('updateChatList', { res, needScrollToBottom: true })
          this.historyMsgList = this.historyMsgList.concat(res.reverse())
          this.isloading = false
        },
        fail: () => {
          this.isloading = false
        }
      }
      WebIM.conn.fetchHistoryMessages(options)
    }
  }
}
</script>

<style lang="stylus">
.chat-history .iconfont.icontime
  margin-right: 10px;
  font-size: 25px;
  cursor: pointer;

.chat-dialog-history
  width 780px

  .el-dialog__header
    background-color $color-main
    padding 6px 20px
    box-sizing border-box

  .el-dialog__body
    padding 0

  .el-dialog__title
    color $color-white
    font-size 16px
    line-height 30px

  .el-dialog__headerbtn {
    top: 13px;
    &:hover {
      .el-dialog__close {
        color: $color-white;
        opacity: 1;
      }
    }
  }

  .el-dialog__close
    color $color-white

  .chat-title__icon
    color $color-white
    margin-right 10px
    cursor pointer

  .chat-title__name
    color $color-white
    margin-right 10px
    font-size 14px
    line-height 30px

  .chat-title__avatar
    width 30px
    height 30px
    border-radius 50%
    margin-left 0
    margin-right 10px

.history-list
  padding 24px
  height 560px
  overflow auto
  margin 24px
  background $color-white
  .msg-item
    display flex
    border-bottom 1px solid $color-black-10
    padding 24px 0
  .msg-item-avatar
    padding 0 12px
    .chat-title__avatar
      margin-right 0
  .msg-item-content
    flex-grow 1
  .msg-item-datetime
    width 120px
    text-align center
    color $color-black-45
    font-size 12px
  .chat-username
    color $color-black-45
    font-size 12px
    line-height 1.5
    margin-bottom 5px
  .msg
    font-size 14px
    line-height 1.5
    color $color-black-65
  .file-style
    width 240px
    margin-bottom 10px
    font-size 13px
  .img-style
    max-width 400px
    margin-bottom 10px
    border-radius 4px
    box-shadow 0 2px 12px 0 $color-black-10
  .card-inner
    padding 10px 14px 14px

    h2
      border-bottom 1px solid $color-gray-e5
      text-align left
      font-size 14px
      line-height 1.5
      padding-bottom 5px

    h3
      max-width 100%
      font-size 12px
      height 20px
      line-height 22px
      font-weight 600
      text-overflow ellipsis
      overflow hidden
      white-space nowrap
      text-align left
      margin-top 8px
      margin-bottom 20px

    .bottom span
      color $color-black-45
      text-align left

    a
      color $color-black-45
      float right
      text-decoration none

    .el-dropdown-link
      cursor pointer
      color $color-blue-50

    .el-icon-arrow-down
      font-size 12px
  .loadmore-btn
    margin 10px auto
    display block
</style>
